/**
 * Application Configuration
 *
 * Centralized configuration using Vite environment variables.
 * All client-side env vars must be prefixed with VITE_
 */

interface AppConfig {
  apiUrl: string;
  appName: string;
  appVersion: string;
  isDevelopment: boolean;
}

// Default values for development
const defaults = {
  // Use empty string for relative URLs to leverage Vite proxy
  // The Vite dev server (port 8000) proxies /auth and /api to backend (port 6000)
  // This avoids ERR_UNSAFE_PORT errors with blocked ports like 6000
  apiUrl: '',
  appName: 'Hardware Digester Lite',
  appVersion: '1.0.0',
};

export const config: AppConfig = {
  // Backend API URL (should match backend PORT in .env)
  // Use VITE_API_URL env var to override, or defaults based on environment
  apiUrl: import.meta.env.VITE_API_URL || defaults.apiUrl,

  // Application metadata
  appName: import.meta.env.VITE_APP_NAME || defaults.appName,
  appVersion: import.meta.env.VITE_APP_VERSION || defaults.appVersion,

  // Environment detection
  isDevelopment: import.meta.env.DEV,
};

// Log configuration in development
if (config.isDevelopment) {
  // eslint-disable-next-line no-console
  console.log('App Configuration:', {
    apiUrl: config.apiUrl,
    appName: config.appName,
    environment: 'development',
  });
}

export default config;
